export const LOADING = 'LOADING';
export const ADD_COLOR = 'ADD_COLOR';
export const REMOVE_COLORS = 'REMOVE_COLORS';
export const REMOVE_ONE_COLOR = 'REMOVE_ONE_COLOR';
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGING_OUT = 'LOGGING_OUT';
export const UPDATE_MY_PALATES = 'UPDATE_MY_PALATES';
export const UPDATE_TITLE_NOTE = 'UPDATE_TITLE_NOTE';
export const TITLE = 'TITLE';
export const NOTE = 'NOTE';
export const PALATE_SAVED = 'PALATE_SAVED';
export const SAVING_PALATE = 'SAVING_PALATE';
